import request from '@/utils/request'


// 查询分佣记录列表
export function listUserGoodsLog(query) {
  return request({
    url: '/comm/user/goods/log/list',
    method: 'get',
    params: query
  })
}

// 查询分佣记录分页
export function pageUserGoodsLog(query) {
  return request({
    url: '/comm/user/goods/log/page',
    method: 'get',
    params: query
  })
}

// 查询分佣记录详细
export function getUserGoodsLog(data) {
  return request({
    url: '/comm/user/goods/log/detail',
    method: 'get',
    params: data
  })
}

// 新增分佣记录
export function addUserGoodsLog(data) {
  return request({
    url: '/comm/user/goods/log/add',
    method: 'post',
    data: data
  })
}

// 修改分佣记录
export function updateUserGoodsLog(data) {
  return request({
    url: '/comm/user/goods/log/edit',
    method: 'post',
    data: data
  })
}

// 删除分佣记录
export function delUserGoodsLog(data) {
  return request({
    url: '/comm/user/goods/log/delete',
    method: 'post',
    data: data
  })
}
